import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { Button, Divider, Grid, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import useModals from 'src/Hooks/useModals'
import { AddressType, AddressesData } from 'src/Libs/shop/models/billling-and-shipping-address-modal.model'
import { makeStyles } from 'tss-react/mui'

interface ConfirmCheckoutShippingAddressProps {
  currentAddress: string | null
  allAddresses: AddressesData
  onAddressChange: (newAddress: string, permanent: boolean) => void
}

const useStyles = makeStyles()(theme => ({
  normalText: {
    color: theme.palette.text.primary,
    borderColor: theme.palette.grey.grey03,
  },
}))

const ConfirmCheckoutShippingAddress: React.FC<ConfirmCheckoutShippingAddressProps> = ({ currentAddress, allAddresses, onAddressChange }) => {
  const { t } = useCustomTranslation()
  const { classes } = useStyles()
  const { openShopBillingAndShippingModal, openShopNewShippingAddressModal } = useModals()
  const [companyName, setCompanyName] = useState<string | null>(null)

  useEffect(() => {
    const fullAddress = allAddresses.shippingAddresses.find(address => address.addressId === currentAddress)
    if (fullAddress) {
      setCompanyName(fullAddress.companyName)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentAddress])

  return (
    <Grid item xs={12} md={6} sx={{ paddingLeft: '24px', paddingRight: '24px' }}>
      <Typography variant="h2" sx={{ fontWeight: 400 }} className={classes.normalText}>
        {t('shop.confirm-checkout.shipping-address')}
      </Typography>
      <Divider className={classes.normalText} variant="fullWidth" />
      <Typography
        className={classes.normalText}
        sx={{
          marginTop: '24px',
          minHeight: '100px',
          marginBottom: '24px',
          lineHeight: '24px',
          whiteSpace: 'pre-line',
        }}
      >
        {companyName && `${companyName}, \n`}
        {currentAddress && currentAddress.replace(',', ',\n')}
      </Typography>
      <Button
        className={classes.normalText}
        disabled={!allAddresses}
        size="large"
        variant="outlined"
        color="inherit"
        sx={{ padding: '20px 32px' }}
        onClick={() => {
          openShopBillingAndShippingModal({
            addressType: AddressType.Shipping,
            defaultAddress: currentAddress,
            addressList: allAddresses.shippingAddresses,
            onConfirm: newAddress => {
              onAddressChange(newAddress, true)
            },
            onNewAddress: onClose => {
              onClose()
              openShopNewShippingAddressModal({
                onConfirm: (companyName, newAddress, permanent) => {
                  onAddressChange(newAddress, permanent)
                  setCompanyName(companyName)
                  onClose()
                },
              })
            },
          })
        }}
      >
        {t('shop.confirm-checkout.change-shipping-address')}
      </Button>
    </Grid>
  )
}

export default ConfirmCheckoutShippingAddress
